import { parseColor } from "../../helper/theme-server-helper";
import { logAdapterEvent, logError } from "../../helper/logger";

const ADAPTER_NAME = "equipmentWizardAdapter";

interface EquipmentWizardAdapterProps {
  content: any;
  componentId: string;
  cmsPageName?: string;
}

export const equipmentWizardAdapter = ({
  content,
  componentId,
  cmsPageName
}: EquipmentWizardAdapterProps): any => {
  // hardcode mandatory content if missing

  try {
    logAdapterEvent(ADAPTER_NAME, "Adapting data for Equipment Wizard", {
      cmsPageName
    });

    const q1Options = [];
    for (let val = 1; val <= 6; val += 1) {
      q1Options.push({
        label: val < 6 ? val.toString() : "6+",
        value: val
      });
    }

    const q2Options = [];
    for (let val = 0; val <= 6; val += 1) {
      q2Options.push({
        label: val < 6 ? val.toString() : "6+",
        value: val
      });
    }

    // provide defaults for optional content
    const updatedContent = {
      ...content,
      id: content?.id || "UF-Equipment-Wizard",
      q1Options,
      q2Options,
      requiredContent: content?.requiredContent,
      content: {
        ...content?.content,
        quizHeading: content?.content?.quizHeading || {
          content:
            "Get a recommendation on how many DIRECTV devices you should get"
        },
        quizSubheading: content?.content?.quizSubheading || {
          content:
            "Answer a couple questions to get you set up with DIRECTV streaming devices."
        },
        q1CtaLabel: content?.content?.q1CtaLabel || "Next",
        q2CtaLabel: content?.content?.q2CtaLabel || "Finish",
        bulletsHeading: content?.content?.bulletsHeading || {
          content: "Pick the better way to watch it all"
        },
        bulletsSubheading: content?.content?.bulletsSubheading || {
          content: ""
        },
        optionsHeading: content?.content?.optionsHeading || {
          content: "Here are some recommendations for you"
        },
        optionsSubheading: content?.content?.optionsSubheading || {
          content: "Choose the best option and we'll remind you at checkout."
        },
        optionsSaveCtaLabelDefault:
          content?.content?.optionsSaveCtaLabelDefault || "Save my selection",
        optionsSaveCtaLabelConfirmed:
          content?.content?.optionsSaveCtaLabelConfirmed || "Selection Saved",
        optionsSaveConfirmationMsg:
          content?.content?.optionsSaveConfirmationMsg ||
          "We'll remind you of your device(s) selection during checkout.",
        redirectModalHeading: content?.content?.redirectModalHeader || {
          content: "Before you continue"
        },
        redirectModalSubheading: content?.content?.redirectModalSubheading || {
          content:
            "We got your devices taken care of, but we noticed you don't have a TV packaged picked yet. Would you like to do that now?"
        },
        redirectModalPrimaryCtaLabel:
          content?.content?.redirectModalPrimaryCtaLabel || "Choose my package",
        redirectModalSecondaryCtaLabel:
          content?.content?.redirectModalSecondaryCtaLabel || "No thanks",
        redirectModalTargetUrl:
          content?.content?.redirectModalTargetUrl || "/packages"
      },
      stylingOptions: {
        componentBgColor: parseColor(content?.componentBgColor) || "#FFF",
        componentBorderColor:
          parseColor(content?.componentBorderColor) || "#9AA0A6",
        cardBgColor: parseColor(content?.quizCardBgColor) || "#F4F4F4"
      }
    };

    return {
      props: {
        ...updatedContent,
        options: {
          id: componentId,
          contentFriendlyName: `Equipment Wizard`
        }
      },
      type: "EQUIPMENTWIZARD"
    };
  } catch (error) {
    logError(ADAPTER_NAME, error, {
      cmsPageName
    });
  }
};

export default equipmentWizardAdapter;
